import React, {useEffect} from 'react';
import {Col, Layout, Row} from 'antd';
import {MyMenuTopMain} from "./menu-top-main";
import {Hub, Logger} from "@aws-amplify/core";
import {AuthService} from "../../services/auth-service";

const {Header} = Layout;

function MyHeader(props) {
    const logger = new Logger('AuthService');

    useEffect(() => {
        Hub.listen('auth', (data) => {
            const {payload} = data;
            onAuthEvent(payload);
        })

        return function cleanup() {
            logger.info("Removing HUB subscription to " + AuthService.CHANNEL);
            // Hub.remove(AuthService.CHANNEL, null);
        };

    });

    function onAuthEvent(payload) {
        // ... your implementation
    }

    return <Header style={{ zIndex: 1, width: '100%', backgroundColor: '#fff'}}>
        <Row gutter={16}>
            {/* <Col flex={'100px'}>
                <img src={logo} style={{width : '150px', height : '100px', marginTop:'-20px', marginLeft: '-35px'}} alt=""></img>
            </Col> */}
            {/* <Col span={8}>
                <SearchInputField/>
            </Col> */}
            <Col flex={'auto'} style={{float: 'right'}}>
                <MyMenuTopMain userHasAuthenticated= {props.userHasAuthenticated}/>
            </Col>
        </Row>
    </Header>
}

export default MyHeader;
